import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import { useAuth } from "../AuthContext";
import iziToast from "izitoast";
import Footer from "./Footer";

export const AddTestSchedule = () => {

    const { apipath, filepath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [organizations, setOrganizations] = useState([]);
    const [exams, setExams] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [activeTab, setActiveTab] = useState("Test");
    const testId = localStorage.getItem('scheduleTest');
    const [imageSrc, setImageSrc] = useState("");
    const [testData, setTestData] = useState({});
    const [formData, setFormData] = useState({
        id: testId,
        shift: "",
        // exam: "",
        // test_name: "",
        // total_questions: 0,
        // marks: "",
        // code: "",
        // description: "",
        // image: null,
        // duration: "",
        start_time: "",
        duration: "",
    });

    // useEffect(() => {
    //     const getOrganizations = async () => {
    //         try {
    //             const response = await axios.post(
    //                 apipath + '/organizations',
    //                 {},
    //                 {
    //                     headers: {
    //                         Authorization: 'Bearer ' + token
    //                     }
    //                 }
    //             );
    //             // console.log(response.data);
    //             if (response.data.status === "unauthentic") {
    //                 iziToast.error({
    //                     message: response.data.message,
    //                     position: "topCenter"
    //                 });
    //                 logout();
    //             }
    //             if (response.data.status === "false") {
    //                 iziToast.error({
    //                     message: response.data.message,
    //                     position: "topCenter"
    //                 });
    //                 return false;
    //             }
    //             setOrganizations(response.data.organizations);
    //         }
    //         catch (error) {
    //             // console.error('Error fetching data:', error);
    //             if (error.status === 401) {
    //                 iziToast.error({
    //                     message: "Un-Authorised! Please Login.",
    //                     position: "topCenter"
    //                 });
    //                 logout();
    //             }
    //             else {
    //                 iziToast.error({
    //                     message: error,
    //                     position: 'topCenter'
    //                 });
    //             }

    //         } finally {

    //         }
    //     }
    //     getOrganizations();
    // }, []);


    // const getExams = async () => {
    //     try {
    //         const response = await axios.post(
    //             apipath + '/exams',
    //             { 'id': formData.organization },
    //             {
    //                 headers: {
    //                     Authorization: 'Bearer ' + token
    //                 }
    //             }
    //         );
    //         // console.log(response.data);
    //         if (response.data.status === "unauthentic") {
    //             iziToast.error({
    //                 message: response.data.message,
    //                 position: "topCenter"
    //             });
    //             logout();
    //         }
    //         if (response.data.status === "false") {
    //             iziToast.error({
    //                 message: response.data.message,
    //                 position: "topCenter"
    //             });
    //             return false;
    //         }
    //         setExams(response.data.exams);
    //     }
    //     catch (error) {
    //         // console.error('Error fetching data:', error);
    //         if (error.status === 401) {
    //             iziToast.error({
    //                 message: "Un-Authorised! Please Login.",
    //                 position: "topCenter"
    //             });
    //             logout();
    //         }
    //         else {
    //             iziToast.error({
    //                 message: error,
    //                 position: 'topCenter'
    //             });
    //         }

    //     } finally {

    //     }
    // }
    // useEffect(() => {
    //     getExams();
    // }, [formData.organization]);

    const getTest = async () => {
        setIsLoading(true);
        try {
            console.log(testId);
            const response = await axios.post(
                apipath + '/getTest',
                { 'id': testId },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setTestData(response.data.test);
            formData.duration = response.data.test?.duration;
            setImageSrc(`${filepath + "/testImages/" + response.data.test?.image}`)
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getTest();
    }, []);


    const [errors, setErrors] = useState({});

    const handleOrganizationChange = (e) => {
        setTotalQuestions(0);
        setFormData({
            ...formData,
            organization: e.target.value,
            exam: "",  // Reset exam when organization changes
            total_questions: 0,
        });
    };
    const handleExamChange = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const questions = selectedOption.getAttribute('data-questions');
        setTotalQuestions(questions);
        setFormData({
            ...formData,
            exam: e.target.value,
            total_questions: questions,  // Reset exam when organization changes
        });
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: files ? files[0] : value,
        }));
        console.log(formData);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.shift) newErrors.shift = "Test Shift is required";
        if (!formData.start_time) newErrors.start_time = "Start date and time are required";
        if (!formData.duration) newErrors.duration = "Result date and time are required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle file input change
    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first selected file
        setFormData({ ...formData, image: file }); // Set the file in the formData state
        setImageSrc(URL.createObjectURL(file));
        // Optionally, add validation for file type/size
        if (file && !file.type.startsWith("image/")) {
            setErrors({ ...errors, image: "Please upload a valid image file" });
        } else {
            setErrors({ ...errors, image: null });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            // Handle form submission
            // console.log(formData);
            // return false;
            setIsLoading(true);

            try {
                const response = await axios.post(
                    apipath + '/add_test_schedule', formData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                else if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    return false;
                }
                else {
                    iziToast.success({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    navigate('/tests');
                }
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }
            }
            finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"schedules"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Add Test Schedule</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-teal-900 to-teal-900 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div className="w-full p-2">
                            <form onSubmit={handleSubmit} className="mx-auto p-4 space-y-6 bg-white rounded-lg shadow-lg max-h-[75vh] overflow-auto">
                                <h2 className="text-2xl font-bold text-teal-800 text-center">Create Test Schedule</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                    {/* Test Name */}
                                    <div>
                                        <label className="block font-medium">Organization</label>
                                        <input disabled className="w-full border px-3 py-2 rounded" value={(testData.organization) ? testData.organization?.name : ""} />
                                    </div>
                                    <div>
                                        <label className="block font-medium">Exam Name</label>
                                        <input disabled className="w-full border px-3 py-2 rounded" value={(testData.exam) ? testData.exam?.exam_name : ""} />
                                    </div>
                                    <div>
                                        <label className="block font-medium">Test Name</label>
                                        <input disabled className="w-full border px-3 py-2 rounded" value={testData.test_name} />
                                    </div>
                                    <div>
                                        <label className="block font-medium">Test Shift</label>
                                        <input
                                            type="text"
                                            name="shift"
                                            value={formData.shift}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                            placeholder="Enter test shift"
                                        />
                                        {errors.shift && <p className="text-red-500 text-sm">{errors.shift}</p>}
                                    </div>

                                    {/* Start Date and Time */}
                                    <div>
                                        <label className="block font-medium">Start Date & Time</label>
                                        <input
                                            type="datetime-local"
                                            name="start_time"
                                            value={formData.start_time}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.start_time && <p className="text-red-500 text-sm">{errors.start_time}</p>}
                                    </div>

                                    {/* result Date and Time */}
                                    <div>
                                        <label className="block font-medium">Test Duration</label>
                                        <input
                                            type="number"
                                            name="duration"
                                            value={formData.duration}
                                            onChange={handleChange}
                                            placeholder="Test Duration"
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.duration && <p className="text-red-500 text-sm">{errors.duration}</p>}
                                    </div>
                                </div>

                                <div className="text-center">
                                    <button type="submit" className="bg-teal-500 text-white px-6 py-2 rounded-md hover:bg-teal-600">
                                        Create Test Schedule
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};